import { FC, useState } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import isEmail from 'validator/lib/isEmail';
import GlobalStyles from '../components/GlobalStyles';
import { theme } from '../theme';
import ForgotPasswordForm from '../components/ForgotPasswordForm';
import Password from '../services/Password';

const PageContainer = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  padding-top: 15vh;
`;

const ForgotPassword: FC = () => {
  const [email, setEmail] = useState<string>('');
  const [error, setError] = useState<false | string>(false);
  const [submitted, setSubmitted] = useState<boolean>(false);

  const handleSubmit = () => {
    setError(false);

    if (isEmail(email)) {
      setSubmitted(true);
      Password.requestPasswordChange(email);
    } else {
      setError('Please enter a valid email address');
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />

      <PageContainer>
        <ForgotPasswordForm
          email={email}
          changeCallback={setEmail}
          submitCallback={handleSubmit}
          submitDisabled={email === ''}
          error={error ? error : undefined}
          submitted={submitted}
        />
      </PageContainer>
    </ThemeProvider>
  );
};

export default ForgotPassword;
